// extracted by mini-css-extract-plugin
export default {"flex":"BillingDivision_flex__WdZOt","title":"BillingDivision_title__Br8Zt","input_text":"BillingDivision_input_text__Ph47o"};